module.exports = "55260aa0f2407a5098d1bc810879157d.wav";


//////////////////
// WEBPACK FOOTER
// ./assets/sfx/slash.wav
// module id = 79
// module chunks = 0